import React from "react";
import { Instagram, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-zinc-900 bg-[#0A0A0A]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7">
            <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#E5B43A] mb-4">
              // Let's Talk
            </div>
            <h3 className="font-display text-5xl md:text-7xl leading-[0.9] tracking-tight">
              Ready when<br />
              <span className="text-[#E5B43A]">you are.</span>
            </h3>
            <a
              href="#contact"
              className="mt-8 inline-flex items-center gap-3 font-display text-2xl tracking-wider border-b-2 border-[#E5B43A] pb-1 hover:text-[#E5B43A] transition-colors"
              data-testid="footer-cta"
            >
              Start Your Program <ArrowUpRight size={24} />
            </a>
          </div>

          <div className="md:col-span-5 grid grid-cols-2 gap-8">
            <div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-4">Explore</div>
              <ul className="space-y-3 text-sm text-zinc-300">
                <li><a href="#services" className="hover:text-[#E5B43A] transition-colors">Services</a></li>
                <li><a href="#programs" className="hover:text-[#E5B43A] transition-colors">Programs</a></li>
                <li><a href="#assessment" className="hover:text-[#E5B43A] transition-colors">Assessment · $25</a></li>
                <li><a href="#houston" className="hover:text-[#E5B43A] transition-colors">Houston</a></li>
                <li><a href="#results" className="hover:text-[#E5B43A] transition-colors">Results</a></li>
              </ul>
            </div>
            <div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-4">Contact</div>
              <ul className="space-y-3 text-sm text-zinc-300">
                <li><a href="mailto:info@gaintimefitness.com" className="hover:text-[#E5B43A] transition-colors break-all">info@gaintimefitness.com</a></li>
                <li>Houston, TX</li>
              </ul>
              <div className="flex items-center gap-3 mt-6">
                <a
                  href="https://instagram.com/gain.time.fitness"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram @gain.time.fitness"
                  className="inline-flex items-center gap-2 border border-zinc-800 px-3 h-9 hover:border-[#E5B43A] hover:text-[#E5B43A] transition-colors"
                  data-testid="social-instagram"
                >
                  <Instagram size={14} />
                  <span className="text-[10px] tracking-[0.2em] uppercase">@gain.time.fitness</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-zinc-900 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src="https://customer-assets.emergentagent.com/job_houston-training-hub/artifacts/5f1feyf5_1781429554579.png" alt="Gain Time Fitness" className="w-7 h-7 object-cover shrink-0" />
            <span className="font-display tracking-widest">GAIN TIME FITNESS</span>
          </div>
          <div className="flex items-center gap-6">
            <a href="/admin/login" className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 hover:text-[#E5B43A] transition-colors" data-testid="footer-admin-link">Admin</a>
            <div className="text-xs tracking-[0.2em] uppercase text-zinc-500">
              © {new Date().getFullYear()} Gain Time Fitness · Houston, TX
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
